
export const GET_TRANSCRIPTS = 'app/GET_TRANSCRIPTS';
export const getTranscripts = params => ({
  type: GET_TRANSCRIPTS,
  payload: params,
});

export const SET_TOTAL_COUNT = 'transcript/SET_TOTAL_COUNT';
export const setTotalCount = totalCount => ({
  type: SET_TOTAL_COUNT,
  payload: totalCount,
})

export const TRY_SEND_TO_EMAIL = 'transcript/TRY_SEND_TO_EMAIL';
export const trySendToEmail = transcriptId => ({
  type: TRY_SEND_TO_EMAIL,
  payload: transcriptId,
})

export const SEND_TO_EMAIL = 'transcript/SEND_TO_EMAIL';
export const sendToEmail = ({ email, transcriptId }) => ({
  type: SEND_TO_EMAIL,
  payload: { email, transcriptId },
})

export const CLEAR_FILTER = 'transcript/CLEAR_FILTER';
export const clearFilter = () => ({
  type: CLEAR_FILTER,
})

/* REMOVE_TRANSCRIPTS */
export const REMOVE_SELECTED_TRANSCRIPTS = 'transcript/REMOVE_SELECTED_TRANSCRIPTS';
export const removeSelectedTranscripts = () => ({
  type: REMOVE_SELECTED_TRANSCRIPTS,
})
export const REMOVE_TRANSCRIPTS = 'transcript/REMOVE_TRANSCRIPTS';
export const removeTranscripts = params => ({
  type: REMOVE_TRANSCRIPTS,
  payload: params,
})
export const ON_REMOVED_TRANSCRIPTS = 'transcript/ON_REMOVED_TRANSCRIPTS';
export const onRemovedTranscripts = params => ({
  type: ON_REMOVED_TRANSCRIPTS,
  payload: params,
})

/* EXPORT */
export const ON_EXPORTING = 'transcript/ON_EXPORTING';
export const onExporting = params => ({
  type: ON_EXPORTING,
  payload: params,
})
export const GET_TRANSCRIPTS_FOR_EXPORT = 'transcript/GET_TRANSCRIPTS_FOR_EXPORT';
export const getTranscriptsForExport = params => ({
  type: GET_TRANSCRIPTS_FOR_EXPORT,
  payload: params,
})

/* SELECT & DESELECT */
export const TRY_UPDATE_SELECTED_TRANSCRIPTS = 'app/TRY_UPDATE_SELECTED_TRANSCRIPTS';
export const tryUpdateSelectedTranscripts = () => ({
  type: TRY_UPDATE_SELECTED_TRANSCRIPTS,
});
export const TRY_STOP_SELECTION_WITH_CHECKBOXES = 'app/TRY_STOP_SELECTION_WITH_CHECKBOXES';
export const tryStopSelectionWithCheckboxes = () => ({
  type: TRY_STOP_SELECTION_WITH_CHECKBOXES,
});
export const SELECT_TRANSCRIPTS = 'app/SELECT_TRANSCRIPTS';
export const selectTranscripts = transcript => ({
  type: SELECT_TRANSCRIPTS,
  payload: transcript,
});
export const DESELECT_TRANSCRIPT = 'app/DESELECT_TRANSCRIPT';
export const deselectTranscript = () => ({
  type: DESELECT_TRANSCRIPT,
});
export const TRY_DESELECT_TRANSCRIPT = 'transcript/TRY_DESELECT_TRANSCRIPT';
export const tryDeselectTranscript = params => ({
  type: TRY_DESELECT_TRANSCRIPT,
  payload: params,
});
export const HIDE_SELECTED_TRANSCRIPT = 'transcript/HIDE_SELECTED_TRANSCRIPT';
export const hideSelectedTranscript = () => ({
  type: HIDE_SELECTED_TRANSCRIPT,
});
export const SHOW_SELECTED_TRANSCRIPT = 'transcript/SHOW_SELECTED_TRANSCRIPT';
export const showSelectedTranscript = () => ({
  type: SHOW_SELECTED_TRANSCRIPT,
});
